/*
  * Header search
  * Fetch addsearch results from the API
  */

import Mustache from 'mustache'

class HeaderSearch {
  constructor() {
    this.headerMobileSearchBtn = document.getElementById('js-header-search-mobile-btn')
    this.headerDesktopSearchBtn = document.getElementById('js-header-search-desktop-btn')
    this.headerSearchResultsContainer = document.getElementById('header-search-results-container')
    this.headerSearchForm = document.getElementById('header-search-form')
    this.searchResultsTemplate = document.getElementById('add-search-results-template').innerHTML
    this.searchResultsWrapper = document.getElementById('header-search-results')
    this.closeHeaderSearchBtn = document.getElementById('js-close-header-search')
    this.searchOpen = false
    this.searchTimeOut = null
    this.ajaxUrl = this.headerSearchForm?.getAttribute('action')
  }

  /*
    * @param {string}
    *
    * @return {object | false}
    */
  async fetchResults(searchQuery) {
    try {
      const response = await fetch(this.ajaxUrl + `?${searchQuery}`)
      const json = await response.json();
      return json
    } catch(e) {
      return false
    }
  }

  /*
    * Handle changes in the search form
    * Timeout is set for the search input
    */
  async handleFormChange() {
    if (!this.searchOpen) return

    clearTimeout(this.searchTimeOut);
    const formData = new FormData(this.headerSearchForm);
    const serialized = new URLSearchParams(formData).toString();
    this.searchTimeOut = setTimeout(async () => {
      const results = await this.fetchResults(serialized)
      if (results) {
        this.renderSearchResults(results)
      }
    }, 500)

  }

  /*
    * Render json data to Mustache template
    * @param {object} - json response data
    */
  renderSearchResults(data) {
    const renderedData = Mustache.render(this.searchResultsTemplate, data)
    this.searchResultsWrapper.innerHTML = renderedData
  }

  /*
    * Handle search form submit
    *
    * @param {event}
    */
  async handleFormSubmit(e) {
    e.preventDefault()
    if (!this.searchOpen) return

    const formData = new FormData(this.headerSearchForm);
    const serialized = new URLSearchParams(formData).toString();
    const results = await this.fetchResults(serialized)

    if (results) this.renderSearchResults(results)
  }

  handleDesktopSearchBtn() {
    this.headerSearchResultsContainer.classList.toggle('hidden')
    this.searchOpen = !this.searchOpen
  }

  /*
    * Close search if clicked outside search | open search buttons
    *
    * @param {event}
    */
  handleCloseSearchWindow(e) {
    if (this.headerSearchResultsContainer.contains(e.target)) return
    if (this.headerDesktopSearchBtn === e.target) return
    if (this.headerDesktopSearchBtn.contains(e.target)) return
    if (this.headerMobileSearchBtn === e.target) return
    if (!this.searchOpen) return

    this.headerSearchResultsContainer.classList.add('hidden')
    this.searchOpen = false
  }

  handleCloseSearch() {
    this.headerSearchResultsContainer.classList.add('hidden')
    this.searchOpen = false
  }


  /*
    * Check all elements exists and init all the related event listners
    */
  init() {
    if (!this.headerDesktopSearchBtn || !this.headerSearchResultsContainer || !this.headerSearchForm || !this.ajaxUrl
    || !this.searchResultsTemplate || !this.searchResultsWrapper || !this.headerMobileSearchBtn || !this.closeHeaderSearchBtn ) {
      console.warn('header search elements not found')
      return
    }
    this.headerDesktopSearchBtn.addEventListener('click', this.handleDesktopSearchBtn.bind(this))
    this.headerMobileSearchBtn.addEventListener('click', this.handleDesktopSearchBtn.bind(this))
    this.headerSearchForm.addEventListener('submit', this.handleFormSubmit.bind(this))
    this.headerSearchForm.addEventListener('input', this.handleFormChange.bind(this))
    this.closeHeaderSearchBtn.addEventListener('click', this.handleCloseSearch.bind(this))
    document.addEventListener('click', this.handleCloseSearchWindow.bind(this))
  }
}

const headerSearch = new HeaderSearch()

export default headerSearch
